module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entries.js
// module id = 1985
// module chunks = 3